import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig } from '../app-config.loader';
import { ErrorLogsSearchRequest, ErrorLogsSearchResponse } from '../shared/models/errorlogs.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogsService {
  private readonly apiBaseUrl: string;

  constructor(appConfig: AppConfig, private readonly http: HttpClient) {
    this.apiBaseUrl = appConfig.settings.apiRoot;
  }

  public search(filters: ErrorLogsSearchRequest): Observable<ErrorLogsSearchResponse> {
    return this.http.post<ErrorLogsSearchResponse>(`${this.apiBaseUrl}/errorlogs/`, filters);
  }

  public parseXML(data: string | null | undefined): Promise<ErrorLogProperties[]> {
    if (!data) return Promise.resolve([]);

    return new Promise(resolve => {
      const arr: ErrorLogProperties[] = [];
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, 'text/xml');
      const properties = xmlDoc.getElementsByTagName('properties')[0].getElementsByTagName('property');
      Array.from(properties)
        .forEach((prop) => {
          let parent = '';
          if (prop.children.length > 0) {
            const firstChild = prop.children[0];
            if (firstChild.nodeName.toLowerCase() === 'structure') {
              return;
            }

            if (firstChild.nodeName.toLowerCase() === 'dictionary') {
              const dictionary = firstChild.children;
              Array.from(dictionary)
                .forEach((dictProp) => {
                  arr.push({
                    chiave: `${prop.getAttribute('key')}.${dictProp.getAttribute('key')}`,
                    valore: dictProp.textContent ?? ''
                  });
                });

              return;
            }
          }

          if (prop.parentElement?.tagName.toLowerCase() === 'structure') {
            parent = prop.parentElement.parentElement!.getAttribute('key') + '.';
          }

          arr.push({
            chiave: `${parent}${prop.getAttribute('key')}`,
            valore: prop.textContent?.trim() ?? ''
          });
        });

      resolve(arr);
    });
  }

  getLevels() {
    return [
      'Information',
      'Debug',
      'Warning',
      'Error'
    ];
  }
}

export interface ErrorLogProperties {
  chiave: string;
  valore: string;
}
